import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./list-divider.module.css";
const ListDivider = forwardRef((props, ref) => {
    const { className, ...otherProps } = props;
    return _jsx("hr", { ...otherProps, ref: ref, className: clsx(styles.divider, className) });
});
ListDivider.displayName = "List.Divider";
export { ListDivider };
